<template>
  <div class="profile-container"
    :style="{ backgroundImage: 'url(' + backgroundGif + ')' }">
    <!-- Back Button -->
    <a class="back-button" @click="playBackSound">⬅ {{ back_label[language] }}</a>

    <h2>{{ translations[language].profileTitle }}</h2>
    <div class="form-container">
      <form id="profileForm" @submit.prevent="saveProfile">>
        
        <label>
          {{ translations[language].nameLabel }}
          <input v-model="user.name" type="text" required />
        </label>

        <label>
          {{ translations[language].ageLabel }}
          <input v-model="user.age" type="number" required min="3" />
        </label>

        <label>
          {{ translations[language].regionLabel }}
          <select v-model="user.region" required>
            <option value="Greece">Greece</option>
            <option value="Italy">Italy</option>
            <option value="Romania">Romania</option>
            <option value="Ukraine">Ukraine</option>
            <option value="United Kingdom">United Kingdom</option>
          </select>
        </label>

        <label>
          {{ translations[language].languageLabel }}
          <select v-model="user.language" required>
            <option value="en">English</option>
            <option value="el">Greek</option>
            <option value="it">Italian</option>
            <option value="ro">Romanian</option>
            <option value="uk">Ukrainian</option>
          </select>
        </label>

        <h3>{{ translations[language].pndLabel }}</h3>

        <label>
          {{ translations[language].weightLabel }}
          <input v-model="user.weight" type="number" required min="10" max="150" />
        </label>

        <label>
          {{ translations[language].heightLabel }}
          <input v-model="user.height" type="number" required min="50" max="200" />
        </label>

        <label>
          {{ translations[language].physicalActivityLabel }}
          <input v-model="user.physicalActivity" type="number" required min="0" max="180" />
        </label>

        <label>
          {{ translations[language].favoriteFoodLabel }}
          <input v-model="user.favoriteFood" type="text" />
        </label>


      </form>
    </div>
    <button type="submit" form="profileForm" @click="playClickSound">  {{ translations[language].saveProfileButton }} </button>
    <!-- <button @click="playBackSound">{{ translations[language].startGameButton }}</button> -->
  </div>
</template>

<script>
import { sounds } from '@/utils/sounds.js';
export default {
  data() {
    return {
      back_label: { en: "Back", el: "Πίσω", it: "Indietro", ro: "Înapoi", uk: "Назад" },

      backgroundGif: require('@/assets/world/maximum.gif'),

      user: {
        name: '',
        age: '',
        region: '',
        language: '',
        weight: '',
        height: '',
        physicalActivity: '',
        favoriteFood: '',
      },

      translations: {
        en: {
          profileTitle: "User Profile",
          nameLabel: "Name:",
          ageLabel: "Age:",
          regionLabel: "Region:",
          languageLabel: "Language:",
          weightLabel: "Weight (kg):",
          heightLabel: "Height (cm):",
          physicalActivityLabel: "Daily physical activity (minutes):",
          favoriteFoodLabel: "Favorite healthy food:",
          saveProfileButton: "Save profile",
          startGameButton: "Back to game",
          pndLabel: "Physical & Nutrition Data",
        },
        el: {
          profileTitle: "Προφίλ Χρήστη",
          nameLabel: "Όνομα:",
          ageLabel: "Ηλικία:",
          regionLabel: "Χώρα:",
          languageLabel: "Γλώσσα:",
          weightLabel: "Βάρος (κιλά):",
          heightLabel: "Ύψος (εκ.):",
          physicalActivityLabel: "Ημερήσια σωματική δραστηριότητα (λεπτά):",
          favoriteFoodLabel: "Αγαπημένο υγιεινό Φαγητό:",
          saveProfileButton: "Αποθήκευση προφίλ",
          startGameButton: "Επιστροφή στο παιχνίδι",
          pndLabel: "Φυσική δραστηριότητα και διατροφικά δεδομένα",
        },
        it: {
          profileTitle: "Profilo Utente",
          nameLabel: "Nome:",
          ageLabel: "Età:",
          regionLabel: "Regione:",
          languageLabel: "Lingua:",
          weightLabel: "Peso (kg):",
          heightLabel: "Altezza (cm):",
          physicalActivityLabel: "Attività fisica giornaliera (minuti):",
          favoriteFoodLabel: "Cibo sano preferito:",
          saveProfileButton: "Salva profilo",
          startGameButton: "Torna al gioco",
          pndLabel: "Dati fisici e nutrizionali",
        },
        uk: {
          profileTitle: "Профіль Користувача",
          nameLabel: "Ім'я:",
          ageLabel: "Вік:",
          regionLabel: "Регіон:",
          languageLabel: "Мова:",
          weightLabel: "Вага (кг):",
          heightLabel: "Зріст (см):",
          physicalActivityLabel: "Щоденна фізична активність (хвилини):",
          favoriteFoodLabel: "Улюблена здорова їжа:",
          saveProfileButton: "Зберегти профіль",
          startGameButton: "Повернутися до гри",
          pndLabel: "Фізичні та харчові дані"
        },
        ro: {
          profileTitle: "Profilul utilizatorului",
          nameLabel: "Nume:",
          ageLabel: "Vârstă:",
          regionLabel: "Regiune:",
          languageLabel: "Limbă:",
          weightLabel: "Greutate (kg):",
          heightLabel: "Înălțime (cm):",
          physicalActivityLabel: "Activitate fizică zilnică (minute):",
          favoriteFoodLabel: "Mâncare sănătoasă preferată:",
          saveProfileButton: "Salvează profilul",
          startGameButton: "Înapoi la joc",
          pndLabel: "Date fizice și nutriționale",
        },
      },
    };
  },

  methods: {
    playClickSound() {
      sounds.click.play();
    },
    playBackSound() {
      sounds.whoosh.play();
      this.startGame();
    },
    async saveProfile() {
      const token = localStorage.getItem("token");

      try {
        const response = await fetch("https://erebus2.athenarc.gr/duse/save-profile", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(this.user),
        });

        const data = await response.json();
        if (response.ok) {
          alert("Profile saved successfully!");
          localStorage.setItem("language", this.user.language);
          this.$router.push({ name: "MainScene" }); // Redirect to Main Scene
        } else {
          alert(data.error || "Error saving profile.");
        }
      } catch (error) {
        alert("Network error!");
      }
    },

    async loadUserProfile() {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await fetch("https://erebus2.athenarc.gr/duse/get-profile", {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await response.json();
        if (data.profile) {
          this.user = data.profile; // Load profile if exists
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },

    startGame() {
      this.$router.push({ name: "MainScene" });
    },
  },

  created() {
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE " + this.language);
  },

  mounted() {
    sounds.settings_menu.play();
    this.loadUserProfile(); // Load user profile on page load
  },

  beforeUnmount() {
    sounds.settings_menu.stop();
  },
};
</script>

<style scoped>
.profile-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #2c3e50;
  color: rgb(0, 0, 0);
  padding: 10px;
  overflow: hidden;
  flex-direction: column; /* Ensure the whole container content is in a single column */
  justify-content: flex-start; /* Align elements from the top */
}

.form-container {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow for better contrast */
  width: 100%;
  max-width: 500px; /* Limiting width */
  max-height: 80vh; /* Ensure it fits on the screen */
  overflow-y: auto; /* Make it scrollable */
  margin: 0 10px; /* Prevent form container from touching the sides */
}

form {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 15px;
}

input,
select {
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

button {
  background-color: #0077cc;
  color: white;
  padding: 12px;
  border: none;
  cursor: pointer;
  margin-top: 15px;
  border-radius: 4px;
}

button:hover {
  background-color: #005fa3;
}

.form-container {
  padding: 15px; /* Reduce padding for mobile screens */
  max-width: 90%;
  max-height: 50vh;
}

input, select, button {
  font-size: 16px; /* Adjust font size for smaller screens */
  padding: 12px; /* Larger padding for easier touch interaction */
}

h2 {
  font-size: 1.5rem; /* Adjust title size */
  background-color: rgba(255, 255, 255, 0.9);
  color: black;
  border-radius: 8px;
  padding: 8px;
}

h3 {
  font-size: 1.25rem; /* Adjust subtitle size */
}

</style>
